/**
 * Video Modal
 */

class VideoModal {
  constructor() {
    this.componentId = 'video-modal';
    this.CLASS_NAMES = {
      BASE: `${this.componentId}`,
      VISIBLE: `${this.componentId}--is-visible`,
      ROOT_VISIBLE: `${this.componentId}-is-visible`,
    };
    this.isLoading = true;
    this.videoModalPlayer = null;
    this.rootElement = document.documentElement;
    this.videoModal = document.querySelector(`.${this.CLASS_NAMES.BASE}`);
    this.handleClick = this.handleClick.bind(this);

    this._setListeners();
  }

  _setListeners() {
    this.rootElement.addEventListener('click', this.handleClick);
  }

  handleYouTubeIframeAPIReady() {
    this.setLoading(false);
  }

  setLoading(isloading) {
    this.isLoading = isloading;
  }

  handleClick(event) {
    const videoPlayElement = event.target.closest(
      `[data-${this.componentId}-play]`
    );
    const videoCloseElement = event.target.closest(
      `[data-${this.componentId}-close]`
    );

    if (videoPlayElement || videoCloseElement) event.preventDefault();

    if (videoPlayElement) {
      const { videoId } = videoPlayElement.dataset;
      return this.play(videoId);
    }

    if (videoCloseElement) return this.close();
  }

  play(videoId) {
    if (this.isLoading) return;

    if (!videoId) {
      console.error(
        'The "video-id" data attribute must be set to a valid YouTube ID.'
      );
      return;
    }

    this.setLoading(true);
    this.videoModal.classList.add(this.CLASS_NAMES.VISIBLE);
    this.rootElement.classList.add(this.CLASS_NAMES.ROOT_VISIBLE);
    this.videoModalPlayer = new YT.Player(`${this.componentId}-iframe`, {
      videoId,
      modestbranding: true,
      rel: 0,
      events: {
        onReady: () => {
          this.setLoading(false);
          this.videoModalPlayer.playVideo();
        },
      },
    });
  }

  close() {
    if (this.isLoading) return;
    this.videoModal.classList.remove(this.CLASS_NAMES.VISIBLE);
    this.rootElement.classList.remove(this.CLASS_NAMES.ROOT_VISIBLE);
    if (this.videoModalPlayer) this.videoModalPlayer.destroy();
  }

  init() {
    loadYouTubeIrameAPI(this.handleYouTubeIframeAPIReady());
  }
}

export default VideoModal;

// Load the Youtube IFrame API script
function loadYouTubeIrameAPI(onReady) {
  // Check to see if we already have a YT ready callback set on the window and cache it.
  let onYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady;

  window.onYouTubeIframeAPIReady = () => {
    onReady && onReady();
    onYouTubeIframeAPIReady && onYouTubeIframeAPIReady();
  };

  if (window.YT) return;
  const youTubeScriptTag = document.createElement('script');
  const firstScriptTag = document.getElementsByTagName('script')[0];
  youTubeScriptTag.src = 'https://www.youtube.com/iframe_api';
  firstScriptTag.parentNode.insertBefore(youTubeScriptTag, firstScriptTag);
}
